import React, { useState, useEffect } from "react";
import moment from "moment";
import "moment/locale/pt-br.js";

import { Col, Form } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import { DatePickerInput } from "rc-datepicker";
import "rc-datepicker/lib/style.css";

import { getMenuData, getlistClass } from "../../../../../services/NexiDigitalAPI";
import FiltroWrapper from "../../../Components/FiltroWrapper";
import styles from "./styles.module.scss";
import ButtonWithLoading from "../../../../../components/ButtonWithLoading";
import CompaniesModal from "../../../../../components/CompaniesModal/CompaniesModal";
import SelectUserModal from "./SelectUserModal";
import CatalogModal from "containers/PeopleCraft/NodeManagerV2/CatalogModal";

const Filtro = ({ actionFilter, loading, expanded, downloadEvent }) => {
  const initData = {
    // startDate: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"),
    // finishDate: moment(new Date()).format("YYYY-MM-DD"),
    startDate: null,
    finishDate: null,
    idCompany: getMenuData().idCompany,
    offset: 0,
    limit: 10,
    idTeam: undefined,
    userStatus: "ALL",
    idUser: undefined,
  };

  const [values, setValues] = useState(initData);
  const [selectedCompany, setSelectedCompany] = useState({});
  const adminLevel = getMenuData()?.admin;

  const [selectedNode, setSelectedNode] = useState(null);
  const [showCatalog, setShowCatalog] = useState(false);
  // const teamReset = [{ value: "all", label: "Todas" }];
  const [team, setTeam] = useState([]);
  const [closeModalCompaniesStatus, setCloseModalCompaniesStatus] = useState(false);

  const [filterByStudent, setFilterByStudent] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const handleSelectedNode = async (node) => {
    setSelectedNode(node);
    setValues((prevData) => ({ ...prevData, nodeCode: node.nodeCode }));
    _getTeams({ nodeCode: node.nodeCode, idCompany: selectedCompany.idCompany });
  };

  async function _getTeams(nodeCode) {
    try {
      const { result: teamRes } = await getlistClass(nodeCode);
      if (teamRes?.length) {
        const formatedData = teamRes.map(({ idTeam, name }) => ({ value: idTeam, label: name }));
        return setTeam(formatedData);
      }
      return setTeam([]);
    } catch {
      return setTeam([]);
    }
  }

  const handleChangeSelect = ({ target }) => {
    const { name, value } = target;
    if (name === "team") setValues((prev) => ({ ...prev, idTeam: value }));
    if (name === "userStatus") setValues((prev) => ({ ...prev, userStatus: value }));
  };

  function handleFilter() {
    if (selectedCompany) {
      return actionFilter({
        ...values,
        idCompany: selectedCompany.idCompany === "all" ? undefined : selectedCompany.idCompany,
      });
    }
    actionFilter(values);
  }

  function handleDateStart(jsDate) {
    const date = moment(jsDate).format("YYYY-MM-DD");
    setValues((prev) => ({ ...prev, startDate: date }));
  }

  function handleDateFinish(jsDate) {
    const date = moment(jsDate).format("YYYY-MM-DD");
    setValues((prev) => ({ ...prev, finishDate: date }));
  }

  function isAdminSecondDegree() {
    return adminLevel >= 2;
  }

  useEffect(() => {
    if (expanded) selectedCompany?.isUserCompany && handleFilter();

    if (selectedCompany.idCompany === "all") {
      setSelectedNode(null);
      setTeam([]);
      setSelectedStudent(null);
      setValues({ ...initData, idCompany: selectedCompany.idCompany });
    }

  }, [selectedCompany, expanded]);

  useEffect(() => {
    if (closeModalCompaniesStatus) {
      handleFilter();
      setCloseModalCompaniesStatus(false);
    }
  }, [closeModalCompaniesStatus]);

  const onCloseModalCompanies = () => {
    setSelectedNode(null);
    setTeam([]);
    setSelectedStudent(null);
    setValues({ ...initData, idCompany: selectedCompany.idCompany });
    setCloseModalCompaniesStatus(true);
  };

  return (
    <FiltroWrapper>
      <Form style={{ marginTop: 30, marginBottom: 30 }}>
        <Form.Row className="align-items-end">
          <Form.Row className="col-md-12 mb-2" style={{ padding: 5 }}>
            <CompaniesModal
              showAllCompaniesOption
              showInput={isAdminSecondDegree()}
              setSelectedCompany={setSelectedCompany}
              selectedCompany={selectedCompany}
              onCloseModal={onCloseModalCompanies}
            />
          </Form.Row>

          <Form.Row className="col-md-12 mb-2" style={{ padding: 5 }}>
            <Form.Check
              type="radio"
              label="Filtrar por Treinamento"
              name="filterMode"
              id="filterByTraining"
              checked={!filterByStudent}
              onChange={() => {
                setFilterByStudent(false);
                setSelectedStudent(null);
                setValues((prev) => ({ ...prev, idUser: undefined }));
              }}
              style={{ marginRight: 16 }}
            />
            <Form.Check
              type="radio"
              label="Filtrar por Aluno"
              name="filterMode"
              id="filterByStudent"
              checked={filterByStudent}
              onChange={() => {
                setFilterByStudent(true);
                setSelectedNode(null);
                setTeam([]);
                setValues((prev) => ({ ...prev, nodeCode: undefined, idTeam: undefined }));
              }}
            />
          </Form.Row>

          <Col xs="6" md="2" lg="2" className={styles.formSpace}>
            <Form.Label htmlFor="startDate">Data de Início*</Form.Label>
            <DatePickerInput locale="pt-br" onChange={handleDateStart} value={values.startDate} maxDate={values.finishDate} />
          </Col>

          <Col xs="6" md="2" lg="2" className={styles.formSpace}>
            <Form.Label htmlFor="finishDate">Data de Término*</Form.Label>
            <DatePickerInput locale="pt-br" onChange={handleDateFinish} value={values.finishDate} minDate={values.startDate} maxDate={new Date()} />
          </Col>

          <Col xs="6" md="4" lg="5" className={styles.formSpace}>
            <Form.Label htmlFor="learnings">{filterByStudent ? "Aluno*" : "Treinamento"}</Form.Label>

            {!filterByStudent ? (
              <>
                <div
                  onClick={() => setShowCatalog(true)}
                  className={selectedCompany.idCompany === "all" ? styles.formControlTreeDisabled : styles.formControlTree}
                  disabled={selectedCompany.idCompany === "all"}
                >
                  {selectedNode && selectedCompany.idCompany !== "all"
                    ? `${selectedNode.nodeCode} - ${selectedNode.title}`
                    : "Selecionar treinamento"}
                </div>

                {showCatalog && (
                  <CatalogModal
                    denyAction={() => setShowCatalog(false)}
                    returnNodeData={handleSelectedNode}
                    isSimpleSelect
                    nodeType="LEARNING"
                    onlyEntrypoints
                    selectedCompany={selectedCompany}
                  />
                )}
              </>
            ) : (
              <>
                <div
                  className={selectedCompany.idCompany === "all" ? styles.formControlTreeDisabled : styles.formControlTree}
                  onClick={() => (selectedCompany.idCompany === "all" ? null : setShowUserModal(true))}
                  disabled={selectedCompany.idCompany === "all"}
                  title={selectedCompany.idCompany === "all" ? "Selecione uma empresa para escolher o aluno" : undefined}
                >
                  {selectedStudent
                    ? `${selectedStudent?.name || "-"}${selectedStudent?.email ? ` - ${selectedStudent.email}` : ""}`
                    : "Selecionar aluno"}
                </div>

                <SelectUserModal
                  key={selectedCompany?.idCompany || "none"}
                  show={showUserModal}
                  idCompany={selectedCompany?.idCompany}
                  onClose={() => setShowUserModal(false)}
                  onSelect={(u) => {
                    const idFromU = u?.idUser ?? u?.id ?? u?.userId ?? u?.iduser ?? undefined;
                    setSelectedStudent(u);
                    setValues((prev) => ({ ...prev, idUser: idFromU }));
                    setShowUserModal(false);
                  }}
                />
              </>
            )}
          </Col>

          {!filterByStudent && (
            <>
              <Col xs="6" md="3" lg="3" className={styles.formSpace}>
                <Form.Label htmlFor="team">Turma</Form.Label>
                <Form.Control
                  id="team"
                  name="team"
                  as="select"
                  value={values.idTeam}
                  onChange={handleChangeSelect}
                  disabled={!selectedNode || team.length === 0 || selectedCompany.idCompany === "all"}
                >
                  {team.length === 0 ? (
                    <option>Nenhuma Turma</option>
                  ) : (
                    <>
                      <option value="ALL">Todas</option>
                      {team?.map(({ label, value }) => (
                        <option value={value} key={value}>
                          {label}
                        </option>
                      ))}
                    </>
                  )}
                </Form.Control>
              </Col>

              <Col xs="12" md="2" lg="2" className={styles.formSpace}>
                <Form.Label htmlFor="userStatus">Status do usuário</Form.Label>
                <Form.Control id="userStatus" name="userStatus" as="select" value={values.userStatus} onChange={handleChangeSelect}>
                  <option value="ALL">Todos</option>
                  <option value="ACTIVE">Apenas ativos</option>
                  <option value="INACTIVE">Apenas inativos</option>
                </Form.Control>
              </Col>
            </>
          )}

          {filterByStudent && (
            <Col xs="12" md="4" lg="3" className={styles.formSpace}>
              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", alignItems: "flex-end" }}>
                <ButtonWithLoading
                  disabled={!values.startDate || !values.finishDate}
                  onClickHandler={handleFilter}
                  loading={loading}
                  text={
                    <>
                      Aplicar filtro <FaFilter style={{ marginLeft: 5 }} />{" "}
                    </>
                  }
                  style={{ width: "100%" }}
                />
                <ButtonWithLoading
                  disabled={!values.startDate || !values.finishDate}
                  onClickHandler={() =>
                    downloadEvent({
                      ...values,
                      idCompany: selectedCompany.idCompany === "all" ? undefined : selectedCompany.idCompany,
                    })
                  }
                  loading={loading}
                  text={<>Download da planilha</>}
                  style={{ width: "100%", backgroundColor: "#0d6efd", borderColor: "#0d6efd" }}
                />
              </div>
            </Col>
          )}
        </Form.Row>

        {!filterByStudent && (
          <Form.Row xs="12" style={{ display: "flex", gap: 4, justifyContent: "flex-end", marginTop: 20 }}>
            <Col xs="12" md="2" lg="2" className={styles.formSpace}>
              <Form.Group className="mb-0">
                <ButtonWithLoading
                  disabled={!values.startDate || !values.finishDate}
                  onClickHandler={handleFilter}
                  loading={loading}
                  text={
                    <>
                      Aplicar filtro <FaFilter style={{ marginLeft: 5 }} />{" "}
                    </>
                  }
                  style={{ width: "100%" }}
                />
              </Form.Group>
            </Col>

            <Col xs="12" md="2" lg="2" className={styles.formSpace}>
              <Form.Group className="mb-0">
                <ButtonWithLoading
                  disabled={!values.startDate || !values.finishDate}
                  onClickHandler={() =>
                    downloadEvent({
                      ...values,
                      idCompany: selectedCompany.idCompany === "all" ? undefined : selectedCompany.idCompany,
                    })
                  }
                  loading={loading}
                  text={<>Download da planilha</>}
                  style={{ width: "100%", backgroundColor: "#0d6efd", borderColor: "#0d6efd" }}
                />
              </Form.Group>
            </Col>
          </Form.Row>
        )}
      </Form>
    </FiltroWrapper>
  );
};

export default Filtro;
